App.addModule(function(app) {

    window.Bugsnag && app.on('exception', e => {
        Bugsnag.notify(e)
    })
})
